// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const EmojiHappyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "EmojiHappy/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.172 14.828a4 4 0 0 0 5.656 0M15 10h-.01M9 10h-.01M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"
}));
export default EmojiHappyIcon;